var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-static-content"},[(_vm.text)?_c('span',{staticClass:"c-rich-text c-rich-text--blue fs-copy-a2",style:(_vm.displayState),domProps:{"innerHTML":_vm._s(_vm.text)}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }